/* jshint esnext: true */
import { APP_NAME, $document } from '../utils/environment';
import AbstractModule from './AbstractModule';

import { unescapeHtml } from '../utils/html';

const MODULE_NAME = 'Calendar';
const EVENT_NAMESPACE = `${APP_NAME}.${MODULE_NAME}`;

export const EVENT = {
    CLICK:              `click.${EVENT_NAMESPACE}`,
    SET_EVENTS:         `setEvents.${EVENT_NAMESPACE}`,
    SELECT_EVENT:       `selectEvent.${EVENT_NAMESPACE}`,
    SET_SELECTED_EVENT: `setSelectedDate.${EVENT_NAMESPACE}`
};

export default class extends AbstractModule {
    constructor(options) {
        super(options);

        // Declaration of properties
        this.cal = null;
        this.$calContainer = this.$el.find('.js-calendar');
        this.$calTitle = this.$el.find('.js-calendar-title');
        this.$calPrice = this.$el.find('.js-calendar-price');

        // Set calender events event
        $document.on(EVENT.SET_EVENTS, (event) => this.updateCalendar(event));

        // Force Select event
        $document.on(EVENT.SET_SELECTED_EVENT, (event) => this.setSelectedDate(event))
    }

    updateCalendar(options) {
        this.cal.setEvents(options.events);
    }

    init() {
        let template = unescapeHtml(this.$el.find('.js-calendar-template').html());
        var self = this;
        this.cal = this.$calContainer.clndr({
            template: unescapeHtml(this.$el.find('.js-calendar-template').html()),
            classes:  {
                past:          'is-past',
                today:         'is-today',
                event:         'has-events',
                selected:      'is-selected',
                inactive:      'is-inactive',
                lastMonth:     'is-last-month',
                nextMonth:     'is-next-month',
                adjacentMonth: 'is-adjacent-month'
            },
            dateParameter:           'datetime',
            showAdjacentMonths:      true,
            adjacentDaysChangeMonth: false,
            trackSelectedDate:       true,
            events:                  [],
            clickEvents:             {
                click: function (target) {
                    self.selectDate(target);
                },
                onMonthChange: function (month) {
                    console.log('you just went to ' + month.format('MMMM, YYYY'));
                }
            },
            render: function (data) {
                return Mustache.render(template, data);
            },
            doneRendering: function () {
                // console.log('this would be a fine place to attach custom event handlers.');
            }
        });
    }

    setSelectedDate(options) {
        let date = new Date(options.datetime);
        let month = date.getMonth();
        let year = date.getFullYear();

        this.cal.setMonth(month);
        this.cal.setYear(year);

        this.$calContainer
            .find('.day')
            .removeClass('is-selected');

        this.$calContainer
            .find('.calendar-day-' + options.datetime)
            .addClass('is-selected');

    }

    selectDate(target) {
        if (!$(target.element).hasClass('is-inactive')) {
            // print message in header.
            this.$calTitle.text(target.events[0].date.long + ', looking good!');
            this.$calPrice.text('£' + target.events[0].price);

            // Trigger select event
            $document.triggerHandler({
                type:      EVENT.SELECT_EVENT,
                departure: target.events[0]
            })
        } else {
            this.$calTitle.text('Choose a date');
            this.$calPrice.text('');
        }
    }

    destroy() {
        super.destroy();
        this.$el.off(`.${EVENT_NAMESPACE}`);
    }
}
